import { Navigate } from 'react-router-dom';

import { resolveInitialLang } from '../lib/langPrefs';

export default function RootRedirect() {
  const lang = resolveInitialLang(navigator.language);
  return <Navigate to={`/${lang}/`} replace />;
}
